module.exports = __webpack_public_path__ + "img/wsczzhjkyypt8.6c3c92aa.png";